import { history } from '../../../../App/history';

export default async (formId: string) => {
  history.push("/invoices/from-dispatch/" + formId);
};
